import {React, useIntersectionObserver, observer, useEffect, useState, classNames, pluralize} from '@api'
import {AnchorButton, Spinner} from '@blueprintjs/core'
import {Tooltip2} from '@api'
import {LoadingIndicator, useCatalogItemsCardViewStore, useStores} from '@modules'
import * as css from './LoadMoreCatalogItemsButton.css'

export const LoadMoreItemsButton = observer<{ timesClicked?: number, itemsPerClick?: number, count?: number, onClick: (e) => void }>(({children, onClick, timesClicked, itemsPerClick, count}) => {
  const [isLoadingMore, setIsLoadingMore] = useState(false),
    {strings} = useStores()
  return (
    <div className={css.root}>
      <div className={css.cardPanel}>
        <div className={css.internal}>
          {isLoadingMore ?
           <Tooltip2 content={strings.loadingMoreItems}><Spinner size={20}/></Tooltip2>
                         :
           <Tooltip2 content={count ? `Load ${(timesClicked * itemsPerClick) + 1} to ${Math.min(count, (timesClicked + 1) * itemsPerClick)} of ${count}` : ''}>
             <AnchorButton
               text={strings.loadMore}
               minimal
               //disabled={store.isLoadingMore}
               onClick={e => {
                 setIsLoadingMore(true)
                 // Let the spinner render first
                 setTimeout(() => onClick(e), 1)
               }}>
               {children}
             </AnchorButton>
           </Tooltip2>}
        </div>
      </div>
    </div>)
})

export const LoadMoreCatalogItemsButton = observer<{ className?: string, count: number, index: number }>(({className, count, index}) => {
  const loadMoreStore = useCatalogItemsCardViewStore(),
    {strings, catalog: {stores: {config}, isProductView, settings: {autoLoadMoreCards}}, itemsPerClick, isLoadingMore, timesClicked, hasMore, onPageForward} = loadMoreStore,
    [intersecting, intersectionRef] = useIntersectionObserver({rootMargin: '100px 0px 0px 0px'})

  useEffect(() => {
    if (autoLoadMoreCards && !isLoadingMore && hasMore && intersecting.isIntersecting) {
      !config.isTesting && onPageForward()
    }
  }, [autoLoadMoreCards && !isLoadingMore && hasMore && intersecting.isIntersecting])

  // trace()

  return (
    index == 0 && isLoadingMore ? null :
    <div className={classNames(className, css.root)} data-index={index} data-type='LoadMoreCatalogItemsButton' data-lod='0' data-show-button={true} ref={intersectionRef}>
      <div className={css.cardPanel}>
        {(!hasMore && !isLoadingMore)
         ? null
         : isLoadingMore || autoLoadMoreCards ?
           <Tooltip2 content={strings.loadingMoreItems}>
             {!isLoadingMore && !intersecting.isIntersecting ? <div /> : isProductView ? <LoadingIndicator/> : <Spinner size={18}/>}
           </Tooltip2> :
           <Tooltip2 content={`Load ${(timesClicked * itemsPerClick) + 1} to ${Math.min(count, (timesClicked + 1) * itemsPerClick)} of ${count}`}>
             <AnchorButton
               text={autoLoadMoreCards ? '' : strings.loadMore}
               minimal
               //disabled={store.isLoadingMore}
               onClick={onPageForward}/>
           </Tooltip2>
        }
      </div>
    </div>)
})


// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/GroupByCatalog_CatalogItems/CardView/LoadMoreProductCatalog/LoadMoreCatalogItemsButton.tsx